<template>
  <b-modal :id="id" @ok="handleOk" size="xl" hide-header no-close-on-backdrop no-close-on-esc>
    
    <h3 class="text-site-primary" v-html="title"/>
    <br>
    <div v-html="renderWithImages(instructions)"/>
    <br>
    <div v-if="minutes" v-html="minutes" />

    <template v-slot:modal-footer="{ ok }">
      <b-button variant="primary" class="bg-site-primary" @click="ok()">Begin</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: `ExamineeInstructionsModal`,
  props: {
    id: String,
    title : String,
    instructions: String,
    timeLimitSeconds : Number,
  },
  computed: {
    minutes() {
      return this.timeLimitSeconds ? `You have <b>${this.timeLimitSeconds / 60} minutes</b> to complete this test. Your time will begin once you select <b>"Begin"</b>` : null
    }
  },
  methods: {
    handleOk(){
      this.$emit('ok')
    },
    renderWithImages(text){
      if(!text) return
      if (text.indexOf(`::img::`) > -1) {
        var textArr = text.split(`::img::`)
        var imageCount = textArr.length
        for(var x = 1; x < imageCount; x++ && x++){
          var metadata = JSON.parse(textArr[x])
          textArr[x] = `<img class="${metadata.class}" id="${metadata.id}" src="${this.$store.getters["examItem/getImage"](metadata.key)}" />`
        }
        text = textArr.join('')
      }

      return text;
    },
  },

};
</script>

<style lang="css" scoped>

</style>